import {getKeyTitle} from "@/common/js/tool";

// 寺院满意度调查地址
export const satisfactionQrcodeUrl = "http://ly.zj-qq.cn/survey/satisfaction"

// 佛事法会满意度调查地址
export const buddhistSatisfactionQrcodeUrl = "" // TODO

export const satisfactionOptionList = [
    { label: "满意", value: 3, score: 10 },
    { label: "较满意", value: 2, score: 8  },
    { label: "一般", value: 1, score: 6  },
    { label: "不满意", value: 0, score: 4  },
];

export const satisfactionTypeOptions = [
    { label: "寺院满意度调查", value: 1 },
    { label: "法务佛事满意度调查", value: 2 },
]

export function getSatisfactionOptionScore (val) {
    const item = satisfactionOptionList.find(o => o.value === val);
    return item ? item.score : 0;
}

export function getSatisfactionOptionText (val) {
    return getKeyTitle(satisfactionOptionList, val, "value", "label");
}

export function getSatisfactionTypeText (val) {
    return getKeyTitle(satisfactionTypeOptions, val, "value", "label");
}